import * as S from '@effect/schema/Schema';
import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
export var AnonymousMember = t.type({
  __typename: t.literal('AnonymousMember'),
  lifetimePoints: t.number
});
export var Member = t.type({
  __typename: t.literal('Member'),
  id: t.string,
  name: t.string,
  lifetimePoints: t.number,
  avatarUrl: nullable(t.string),
  showOnLeaderBoard: t["boolean"]
});
export var LeaderboardMember = t.union([Member, AnonymousMember]);
var Rank = t.type({
  memberCount: t.number,
  members: t.array(LeaderboardMember),
  myRank: t["boolean"],
  points: t.number,
  rank: t.number
});
export var Leaderboard = t.type({
  id: t.string,
  name: t.string,
  relative: t.array(Rank),
  top: t.array(Rank)
});
var Profile = t.type({
  id: t.string,
  isAdmin: t["boolean"],
  showOnLeaderBoard: t["boolean"]
});
export var GetLeaderboardQuery = t.type({
  profile: Profile,
  leaderboards: t.array(Leaderboard)
});
export var GetLeaderboardInput = t.type({
  profileId: t.string
});
export var HideMeFromLeaderboard = t.type({
  hideMeFromLeaderboard: t.array(Leaderboard)
});
export var ShowMeOnLeaderboard = t.type({
  showMeOnLeaderboard: t.array(Leaderboard)
});
export var LeaderboardBlockConfig = S.struct({
  typename: S.literal('LeaderboardBlock'),
  id: S.string,
  hash: S.string
});